import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './success-message.component.html',
  styleUrls: ['./success-message.component.scss'],
  imports: [AsyncPipe, MatIcon, MatButtonModule, CommonModule]
})
export class SuccessMessageComponent {
  constructor(private matSnackBarRef: MatSnackBarRef<SuccessMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: Observable<string>, showDismissIcon: boolean }) {
  }

  dismiss() {
    this.matSnackBarRef.dismiss();
  }
}
